// api/pickups.ts
import { apiClient } from './client';

export const pickupsAPI = {
    createPickup: async (data: any) => {
        const response = await apiClient.post('/vendors/pickups/', data);
        return response.data;
    },

    updatePickup: async (id: number, data: any) => {
        const response = await apiClient.put(`/vendors/pickups/${id}/`, data);
        return response.data;
    },

    deletePickup: async (id: number) => {
        const response = await apiClient.delete(`/vendors/pickups/${id}/`);
        return response.data;
    },

    generateLabels: async (pickupId: number, payload?: { assignments?: any[] }) => {
        const response = await apiClient.post(`/vendors/pickups/${pickupId}/generate-labels/`, payload ?? {});
        return response.data;
    },

    assignBoxes: async (pickupId: number, assignments: { box_id: number; item_id: number; quantity: number }[]) => {
        const response = await apiClient.post(`/vendors/pickups/${pickupId}/assign-boxes/`, { assignments });
        return response.data;
    },

    uploadPhotos: async (pickupId: number, fd: FormData) => {
        const response = await apiClient.post(
            `/vendors/pickups/${pickupId}/upload-photos/`,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    },

    submitPickup: async (pickupId: number) => {
        const response = await apiClient.post(`/vendors/pickups/${pickupId}/submit/`);
        return response.data;
    },

    setDefaultStoreAddress: async (addressId: number, storeId: number) => {
        const response = await apiClient.post('/vendors/store-addresses/set-default/', {
            address_id: addressId,
            store_id: storeId,
        });
        return response.data;
    },
    async getAddressesForStores(storeIds: number[]) {
        const params = new URLSearchParams();
        storeIds.forEach(id => params.append('store_ids', String(id)));
        const response = await apiClient.get(
            `/vendors/pickups/addresses-for-stores/?${params.toString()}`
        );
        console.log(response)
        return response.data;
    },

    async getPickupRequests(params?: {
        status?: string;
        page?: number;
        page_size?: number;
    }) {
        const response = await apiClient.get('/vendors/pickups/', { params });
        return response.data;
    },

    async getPickupRequest(id: number) {
        const response = await apiClient.get(`/vendors/pickups/${id}/`);
        return response.data;
    },

    // async createPickup(data: {
    //     address_id: number;
    //     pickup_type: 'quick' | 'detailed';
    //     items: { product_id: number; quantity: number }[];
    //     boxes?: any[];
    //     notes?: string;
    // }) {
    //     const response = await apiClient.post('/vendors/pickups/', data);
    //     return response.data;
    // },

    async cancelPickup(id: number) {
        const response = await apiClient.post(`/vendors/pickups/${id}/cancel/`);
        return response.data;
    },
};

export default pickupsAPI;